import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-default-date-range-selector',
    templateUrl: './default-date-range-selector.component.html',
    styleUrls: ['./default-date-range-selector.component.scss'],
    standalone: false
})
export class DefaultDateRangeSelectorComponent implements OnInit {
  @Input() parentForm: UntypedFormGroup;

  get defaultDateRangeGroup(): FormGroup {
    return this.parentForm.get('defaultDateRange') as FormGroup;
  }

  ngOnInit(): void {
    this.updateCustomValidators();
  }

  onKindChange(kind: string) {
    this.defaultDateRangeGroup.get('kind')?.setValue(kind);
    this.updateCustomValidators();
  }

  private updateCustomValidators(): void {
    const kind = this.defaultDateRangeGroup.get('kind')?.value;
    const customGroup = this.defaultDateRangeGroup.get('custom') as FormGroup;
    const startCtrl = customGroup.get('start');
    const endCtrl = customGroup.get('end');

    if (kind === 'custom') {
      startCtrl?.setValidators([Validators.required]);
      endCtrl?.setValidators([Validators.required]);
    } else {
      startCtrl?.clearValidators();
      endCtrl?.clearValidators();
    }
    startCtrl?.updateValueAndValidity();
    endCtrl?.updateValueAndValidity();
    customGroup.updateValueAndValidity();
  }
}
